import type { l10n } from './l10n';

/**
 * Romanian translations
 * Must match the structure of the structure translation file
 */
export const ro: l10n = {
  // Top Bar
  topBar: {
    search: 'Căutare',
    feed: 'Flux',
    campaigns: 'Campanii',
    ideas: 'Idei',
    community: 'Comunitate',
    premiumPackages: 'Pachete premium',
    profile: 'Profil',
    home: 'Acasă',
    inbox: 'Mesaje',
    more: 'Mai mult',
    publish: 'Publică',
  },

  // Account Info (sheet entries + their dedicated pages)
  accountInfo: {
    unlockedVideos: 'Videoclipuri deblocate',
    subscriptions: 'Abonamente',
    subscribers: 'Abonați',
    likes: 'Aprecieri',
    watchLater: 'Vizionează mai târziu',
    favouritePeople: 'Persoane favorite',
    walletDescription: 'Stare și istoricul tranzacțiilor',
    unlockedVideosDescription: 'Videoclipuri pe care le-ai deblocat',
    subscriptionsDescription: 'Persoane la care te-ai abonat',
    subscribersDescription: 'Persoane abonate la conținutul tău exclusiv',
    likesDescription: 'Videoclipuri pe care le-ai apreciat',
    watchLaterDescription: 'Videoclipuri pe care le-ai salvat',
    favouritePeopleDescription: 'Persoane pe care le-ai salvat',
  },
  admin: {
    entryTitle: 'Administrare',
    entryDescription: 'Secțiune de administrare',
    identityVerifications: 'Verificări de identitate',
    identityVerificationsDescription: 'Vezi solicitările noi și în așteptare de verificare a identității',
    latestUsers: 'Utilizatori recenți',
    latestUsersDescription: 'Vezi cele mai recente conturi create',
    feedback: 'Feedback',
    feedbackDescription: 'Vezi feedbackul utilizatorilor din aplicație',
    transactions: 'Tranzacții',
    transactionsDescription: 'Vezi cele mai recente tranzacții',
  },

  // Routes
  routes: {
    home: 'Acasă',
    inbox: 'Mesaje',
    more: 'Mai mult',
    profile: 'Profil',
    settings: 'Setări',
  },

  // Theme Selector
  themeSelector: {
    title: 'Preferințe temă',
    light: 'Luminos',
    dark: 'Întunecat',
    system: 'Sistem',
    description: 'Tema sistemului urmează setările de aspect ale dispozitivului',
  },

  // iOS Compatibility
  iosCompatibility: {
    title: 'Actualizare iOS necesară',
    message: 'Dispozitivul dvs. rulează iOS {iOSVersion}, care nu este suportat de Expause web.',
    recommendationsTitle: 'Pentru a continua:',
    recommendations: {
      updateIOS: 'Actualizați iPhone-ul la iOS 16 sau mai nou',
      downloadApp: 'Descărcați aplicația mobilă Expause din App Store',
      useDifferentDevice: 'Sau accesați Expause de pe un alt dispozitiv',
    },
    buttonText: 'Obțineți aplicația Expause',
    footerNote: 'Această limitare se datorează funcțiilor de securitate ale browserului pe versiunile mai vechi de iOS. Aplicația nativă oferă experiența completă Expause.',
  },

  // Content
  content: {
    unlock: 'Deblochează',
    unlockFullVideoForCoins: 'Deblochează pentru {coins} monede   >>',
    unlockFor: 'Deblochează pentru',
    views: 'vizualizări',
    scheduled: 'Programat',
    earlyAccess: 'Acces anticipat',
    premium: 'Premium',
    fourK: '4k',
    unlockFourK: 'Deblochează 4k',
    share: 'Distribuie',
    nsfw: 'NSFW',
    nsfwInfoTitle: 'NSFW',
    nsfwInfoMessage: 'Videoclipul a fost marcat ca posibil deranjant, ofensator sau ne-corespunzător. Îl poți viziona pe propria răspundere.',
    nsfwInfoMessageOwn: 'Videoclipul a fost marcat ca posibil deranjant, ofensator sau ne-corespunzător. Alții îl pot viziona pe propria răspundere.',
    nsfwTapToReveal: 'Arată oricum',
    link: 'Video conectat',
    repliedTo: 'Răspuns la {name}',
    publishDraft: 'Publică ciorna',
    blockedTapToAppeal: 'Blocat - Apasă pentru a contesta',
    noVideosAvailable: 'Nu există videoclipuri disponibile',
    errorFetchingFeed: 'A apărut o eroare la afișarea videoclipurilor',
    errorLoadingVideo: 'A apărut o eroare la încărcarea videoclipului',
    contentNotFound: 'Conținutul nu a fost găsit',
    unlockVideo: 'Deblochează videoclipul',
    accessGranted: 'Acces acordat',
    accessGrantedDescription: 'Ai deja acces complet la acest videoclip.',
    unlockDisabledDescription: 'Deblocarea a fost dezactivată pentru acest videoclip. Abonează-te la {name} pentru acces la videoclipul complet.',
    unlockDescription: 'Deblochează pentru acces la videoclipul complet. Doar {name} va ști că l-ai deblocat.',
    coinsWillBeCharged: '{coins}¢ will be charged from your Wallet.',
    insufficientCoins: 'Monede insuficiente. Ai nevoie de încă {amount} monede.',
    rechargeWallet: 'Reîncarcă portofelul',
    rechargeNotAvailable: 'Reîncărcarea portofelului nu este disponibilă pe web. Te rugăm să folosești aplicația mobilă.',
    contentUnlockError: 'A apărut o eroare. Te rugăm să încerci din nou!',
    processingTitle: 'Se procesează',
    processingDescription: 'Acest videoclip este încă în curs de procesare. Te rugăm să revii într-un moment.',
  },

  // Send Gift
  gift: {
    sendGift: 'Trimite cadou',
    send: 'Trimite',
    recharge: 'Reîncarcă',
    syncing: 'Se sincronizează',
    noGifts: 'Nu sunt cadouri disponibile',
    noGiftsYet: 'Încă nu sunt cadouri',
    sendGiftError: 'A apărut o eroare la trimiterea cadoului!',
  },

  // Common
  common: {
    tryAgain: 'Încearcă din nou',
    loadMore: 'Încarcă mai mult',
    loading: 'Se încarcă...',
    genericError: 'A apărut o eroare',
    noData: 'Fără date',
    reachedEnd: 'Ai ajuns la sfârșit',
    back: 'Înapoi',
    close: 'Închide',
    cancel: 'Anulează',
    confirm: 'Confirmă',
    previous: 'Înapoi',
    next: 'Următorul',
    yes: 'Da',
    no: 'Nu',
    ok: 'OK',
    coins: 'monede',
    copy: 'Copiază',
    copied: 'Copiat',
    today: 'Astăzi',
    yesterday: 'Ieri',
    tomorrow: 'Mâine',
    share: 'Distribuie',
    subscriber: 'Abonat',
    meSubscriber: 'Abonament',
    subscribe: 'Abonează-te',
    unsubscribe: 'Dezabonează-te',
    unknownError: 'Eroare necunoscută',
    retrying: 'Se reîncearcă...',
    videos: 'Videoclipuri',
    subscribers: 'Abonați',
    likes: 'Aprecieri',
    message: 'Mesaj',
    processing: 'Se procesează...',
    emptyPlaceholder: '-',
    logoText: 'XII',
    subscribed: 'Abonat',
    videoThumbnail: 'Miniatură video',
    notImplementedYetTitle: 'Încă neimplementat',
    notImplementedYetMessage: 'Va fi disponibil în curând',
    account: 'Cont',
    editProfile: 'Editează profilul',
    community: 'Comunitate',
    subscription: 'Abonament',
    free: 'Gratuit',
    cancelRequest: 'Anulează cererea',
    settings: 'Setări',
    premium: 'Premium',
    chat: 'Chat',
  },
  // User Actions
  userActions: {
    reportUser: 'Raportează',
    blockUser: 'Blochează',
    unblockUser: 'Deblochează',
    blockUserTitle: 'Blochează pe {firstName}',
    unblockUserTitle: 'Deblochează pe {firstName}',
    blockUserDescription:
      'Nu va putea să îți trimită mesaje directe, să îți vadă profilul sau videoclipurile tale. Încă vă puteți vedea reciproc în comunitățile comune. Orice abonament Exclusiv în curs va fi anulat. Nu va fi notificat că l-ai blocat.',
    unblockUserDescription:
      'Va putea să îți trimită mesaje directe, să îți vadă profilul sau videoclipurile tale.',
    viewProfile: 'Vezi profil',
    shareProfile: 'Distribuie profil',
    shareProfileWithFriends: 'Distribuie profilul cu prietenii',
    shareProfileOutsideExpause: 'Distribuie profilul în afara Expause',
    shareTitle: '{firstName} {lastName} pe Expause',
    shareText: 'Vezi profilul lui {firstName} pe Expause!',
    appealBlockedAccount: 'Contestă contul blocat',
    saveToFavouritePeople: 'Salvează la Persoane favorite',
    removeFromFavouritePeople: 'Elimină din Persoane favorite',
    socialShareError: 'A apărut o eroare la distribuire',
    blockError: 'A apărut o eroare. Te rugăm să încerci din nou!',
    settings: 'Setări',
    helpAbout: 'Ajutor și despre',
    logout: 'Deconectare',
    deleteAccount: 'Șterge contul',
    logoutConfirmTitle: 'Deconectare',
    logoutConfirmMessage: 'Ești sigur că vrei să te deconectezi?',
  },

  // Search Users
  searchUsers: {
    searchPlaceholder: 'Caută...',
    noSubscriptions: 'Abonații tăi și persoanele la care te-ai abonat apar aici',
    noSearchResults: 'Nu s-au găsit rezultate',
    writeMessage: 'Scrie un mesaj...',
    selectedUsersEmpty: 'Persoanele pe care le selectezi apar aici',
  },

  // Share
  share: {
    success: 'Gata',
    error: 'A apărut o eroare la partajare. Te rugăm să încerci din nou!',
  },

  reportUser: {
    sheetTitle: 'Raportează',
    chooseReasonTitle: 'Alege un motiv',
    submitStepTitle: 'Trimite raportul',
    commentPlaceholder: 'Adaugă un comentariu (opțional)',
    submit: 'Gata',
    submitSuccess: 'Raport trimis',
    submitError: 'Trimiterea raportului a eșuat. Te rugăm să încerci din nou.',
  },

  reportContent: {
    chooseReasonTitle: 'Alege un motiv',
    submitStepTitle: 'Trimite raportul',
    commentPlaceholder: 'Adaugă un comentariu (opțional)',
    submit: 'Gata',
    submitSuccess: 'Raport trimis',
    submitError: 'Trimiterea raportului a eșuat. Te rugăm să încerci din nou.',
  },

  appealUserReport: {
    title: 'Contestație raport',
    subtitle: 'Contestă blocarea contului tău',
    description: 'Vom analiza contestația ta și vom lua măsurile corespunzătoare. Dacă considerăm că nu ai încălcat nicio politică, îți vom debloca contul.',
    commentPlaceholder: 'Scrie contestația ta (obligatoriu)',
    submit: 'Gata',
    submitSuccess: 'Contestație trimisă!',
    submitError: 'Trimiterea contestației a eșuat. Te rugăm să încerci din nou.',
    emptyCommentError: 'Trebuie să scrii contestația înainte de a o trimite!',
  },

  appealContentReport: {
    title: 'Contestație raport',
    subtitle: 'Contestă blocarea conținutului tău',
    description: 'Vom analiza contestația ta și vom lua măsurile corespunzătoare. Dacă considerăm că nu ai încălcat nicio politică, vom debloca acest conținut.',
    commentPlaceholder: 'Scrie contestația ta (obligatoriu)',
    submit: 'Gata',
    submitSuccess: 'Contestație trimisă!',
    submitError: 'Trimiterea contestației a eșuat. Te rugăm să încerci din nou.',
    emptyCommentError: 'Trebuie să scrii contestația înainte de a o trimite!',
  },

  // Content Actions
  contentActions: {
    shareWithFriends: 'Distribuie cu prietenii',
    shareOutsideExpause: 'Distribuie în afara Expause',
    saveToWatchLater: 'Salvează la Vezi mai târziu',
    removeFromWatchLater: 'Elimină din Vezi mai târziu',
    hide: 'Ascunde',
    hideContentTitle: 'Ascunde',
    hideContentDescription: 'Nu vei mai putea vedea acest videoclip, inclusiv în căutări sau în profilul utilizatorului. De asemenea, vei vedea mai puține videoclipuri similare. Ești sigur că vrei să îl ascunzi?',
    hideContentConfirm: 'Da',
    report: 'Raportează',
    delete: 'Șterge',
    appealBlockedContent: 'Contestă conținutul blocat',
    processing: 'Conținutul este procesat...',
    publishDraft: 'Publică ciornă',
    publishScheduledContent: 'Publică conținutul programat',
    linkContent: 'Conectează conținut',
    unlinkContent: 'Dezconectează conținut',
    unlinkContentTitle: 'Dezconectează conținut',
    unlinkContentDescription: 'Sigur vrei să dezconectezi?',
    unlinkContentConfirm: 'Dezconectează',
    deletePhotoTitle: 'Șterge fotografia',
    deleteVideoTitle: 'Șterge videoclipul',
    deleteContentDescription: 'Odată șters, videoclipul nu mai poate fi recuperat. Sigur vrei să ștergi videoclipul?',
    deleteContentConfirm: 'Șterge',
    scheduledContentTitle: 'Conținut programat',
    scheduledContentDescription: 'Ora la care va fi publicat conținutul: {date}',
    publishNow: 'Publică acum',
    linkSuccess: 'Gata',
    unlinkSuccess: 'Gata',
    publishDraftSuccess: 'Gata',
    publishScheduledSuccess: 'Gata',
    linkError: 'Nu am putut lega. Te rugăm să încerci din nou!',
    unlinkError: 'Nu am putut elimina legătura. Te rugăm să încerci din nou!',
    publishDraftError: 'Nu am putut publica ciorna. Te rugăm să încerci din nou!',
    publishScheduledError: 'Nu am putut publica conținutul. Te rugăm să încerci din nou!',
    deleteContentError: 'Nu am putut șterge conținutul. Te rugăm să încerci din nou!',
    replay: 'Reluare',
    play: 'Redă',
    pause: 'Pauză',
    skip: 'Omite',
    saved: 'Salvat',
  },

  // Edit User Profile
  editUserProfile: {
    title: 'Editează informații',
    chooseProfileImage: 'Alege imaginea de profil',
    changeProfileImage: 'Schimbă',
    basicInfoSection: 'Informații de bază',
    subscriptionSection: 'Abonamente exclusive',
    nameLabel: 'Nume: ',
    usernameLabel: 'Utilizator: ',
    bioLabel: 'Bio: ',
    namePlaceholder: 'Nume',
    usernamePlaceholder: 'Nume de utilizator',
    bioPlaceholder: '(opțional)',
    usernameHint: 'Abonații tăi și persoanele la care te-ai abonat pot folosi numele de utilizator pentru a te menționa în comentarii sau descrierea videoclipurilor.',
    subscriptionDescription: 'Setează un preț între 0 și 100 USD pentru ca abonații să te plătească lunar pentru acces la conținutul tău exclusiv, mesagerie directă și comunitatea ta LIVE.',
    subscriptionDescriptionEditing: ' Abonații activi își vor păstra prețurile curente.',
    subscriptionChargePlaceholder: 'Introduceți suma',
    doneButton: 'Gata',
    usernameNotAvailable: 'Numele de utilizator nu este disponibil!',
    validationTitle: 'Câmpuri lipsă',
    validationDescription: 'Te rugăm să completezi câmpurile obligatorii!',
    limitExceededTitle: 'Limită depășită',
    limitExceededDescription: 'Poți seta un preț maxim de 100 USD pentru abonamentele exclusive.',
    saveErrorTitle: 'Eroare',
    saveErrorDescription: 'A apărut o eroare la salvarea datelor. Te rugăm să încerci din nou!',
    errorOk: 'Ok',
  },

  // User Details
  userDetails: {
    notLoggedInTitle: 'Trebuie să fii autentificat',
    notLoggedInMessage: 'Te rugăm să te autentifici pentru a vizualiza profilurile.',
    loadErrorTitle: 'Eroare la încărcarea profilului',
    accountBlocked: 'Cont blocat',
    accountNotAvailable: 'Cont indisponibil',
    accountUnavailable: 'Acest cont este momentan indisponibil.',
    noVideosOwn: 'Niciun videoclip încă. Încarcă primul tău videoclip!',
    noVideos: 'Niciun videoclip încă',
    addFirstVideo: 'Adaugă primul tău videoclip',
    shareExpause: 'Distribuie Expause',
    account: 'Cont',
  },

  // Subscribe User Sheet
  subscribeUser: {
    titleApprovalRequired: 'Aprobare necesară',
    titleSubscribe: 'Abonează-te',
    titleUnsubscribe: 'Dezabonează-te',
    titleCancelRequest: 'Anulează cererea',
    descriptionApprovalRequired:
      'Trimite o cerere de abonare pentru a obține acces la videoclipurile exclusive ale lui {firstName}, mesageria directă și comunitatea LIVE',
    descriptionSubscribe:
      'Abonează-te pentru a obține acces la videoclipurile exclusive ale lui {firstName}, Acces Anticipat la videoclipurile programate, Mesagerie directă, Apeluri video private, Streaming LIVE și Comunitate',
    descriptionUnsubscribe:
      'Prin dezabonare pierzi accesul la videoclipurile exclusive ale lui {firstName}, Acces Anticipat la videoclipurile programate, Mesagerie directă, Apeluri video private, Streaming LIVE și Comunitate\n\nPlata pentru luna în curs nu va fi returnată în contul tău',
    descriptionCancelRequest: 'Anulează cererea de abonare trimisă către {firstName}',
    descriptionCoinsAddendum:
      '\n\nAbonamentul se bazează pe Monede achiziționate din Magazin și se va reînnoi automat în fiecare lună dacă ai suficiente monede în portofelul contului tău',
    descriptionCancelAddendum:
      '\n\nPoți anula abonamentul oricând selectând Dezabonează-te din profilul lui {firstName}',
    descriptionApprovalNotifyAddendum: '\n\nVei fi notificat când va fi gata',
    positiveSendRequest: 'Trimite cererea',
    positiveSubscribe: 'Abonează-te',
    positiveUnsubscribe: 'Dezabonează-te',
    positiveCancelRequest: 'Anulează cererea',
    freeSubscription: 'Abonament gratuit',
    monthlyPriceLabel: 'Preț lunar: {amount}',
    policyDisclaimerPrefix: 'Continuând, ești de acord cu ',
    policyDisclaimerLinkText: 'Politica privind Abonamentele Exclusive',
    testModeAutoRenewDisclaimer: 'Notă: în modul de test abonamentul se va reînnoi automat la fiecare 10 minute!',
    genericError: 'A apărut o eroare. Te rugăm să încerci din nou!',
    insufficientCoinsTitle: 'Monede insuficiente',
    insufficientCoinsMessage: 'Nu ai suficiente monede. Te rugăm să îți reîncarci portofelul mai întâi!',
  },

  // Review Exclusive Subscription Sheet
  reviewExclusiveSubscription: {
    title: 'Cerere de abonare',
    body: 'Confirmă accesul la conținutul tău exclusiv, mesageria directă și comunitatea cu sesiuni Live',
    reject: 'Respinge',
  },

  // Premium Packages
  premiumPackages: {
    title: 'Pachete premium',
    policyText: 'Accesează funcții suplimentare cu Pachetele Premium.\nAbonându-te, ești de acord cu ',
    premiumSubscriptionsPolicy: 'Politica Pachetelor Premium',
    and: ' și ',
    coinsPolicy: 'Politica Monedelor',
    restorePurchases: 'Restaurează achizițiile',
    monthly: 'lunar',
    subscribeInfoTitle: 'Abonare',
    subscribeInfoMessage: 'Achizițiile în aplicație nu sunt disponibile pe web încă. Te rugăm să folosești aplicația mobilă pentru a te abona la un Pachet Premium.',
    restoreInfoTitle: 'Restaureaza achizițiile',
    restoreInfoMessage: 'Restaurarea achizițiilor nu este disponibilă pe web încă. Te rugăm să folosești aplicația mobilă pentru a restaura achizițiile.',
    verifyInfoTitle: 'Verificare identitate',
    verifyInfoMessage: 'Verificarea identității nu este disponibilă pe web încă. Te rugăm să folosești aplicația mobilă pentru verificare.',
    identityInfoTitle: 'Verificarea identității',
    identityInfoMessage: 'Verificarea identității îți permite să îți dovedești identitatea pe Expause. Odată verificat, o insignă va apărea pe profilul tău.',
    noPremiumPackages: 'Nu există pachete premium disponibile',
    inAppPurchaseStatus: {
      subscribe: 'Abonează-te',
      processing: 'Se procesează...',
      active: 'Activ',
      error: 'Eroare',
      canceled: 'Anulat',
      paused: 'În pauză',
    },
    verificationStatus: {
      getVerified: 'Verifică-te',
      requested: 'Verificare solicitată',
      inReview: 'Verificare în curs',
      declined: 'Verificare respinsă',
      approved: 'Verificat',
    },
  },

  // Wallet
  wallet: {
    title: 'Portofel',
    transactionsTitle: 'Tranzacții',
    virtual: 'VIRTUAL',
    noTransactions: 'Nu ai nicio tranzacție',
    linkRevolut: 'Conectează Revolut',
    linkingRevolut: 'Se conectează Revolut',
    unlinkRevolut: 'Deconectează Revolut',
    withdraw: 'Retrage',
    buyCoins: 'Cumpără Monede',
    recharged: 'Ai reîncărcat',
    withdrawn: 'Ai retras',
    autoWithdrawn: 'Retragere automată',
    subscribed: 's-a abonat la',
    subscriptionRenewed: 'abonamentul a fost reînnoit',
    contentGift: 'un cadou de conținut',
    liveGift: 'un cadou Live',
    videoCallGift: 'un cadou apel video',
    chatGift: 'un cadou de chat',
    earnedPremium: 'Câștigat prin Premium',
    paidPremiumVideo: 'a plătit pentru Video Premium',
    paidBoostVideo: 'a plătit pentru Boost Video',
    unlockedVideo: 'video complet',
    donated: 'a donat pentru o',
    youDonatedFor: 'Ai donat pentru o',
    someoneDonatedFor: 'Cineva a donat pentru o',
    idea: 'Idee',
    someoneRecharged: 'Cineva a reîncărcat',
    someoneWithdrawn: 'Cineva a retras',
    someoneAutoWithdrawn: 'Cineva a retras automat',
    you: 'tu',
    your: 'al tău',
    coins: 'monede',
    youSent: 'Ai trimis',
    sent: 'a trimis',
    youUnlocked: 'Ai deblocat',
    unlocked: 'a deblocat',
    to: 'la',
  },

  // Settings
  settings: {
    title: 'Setări',
    privacy: 'Confidențialitate',
    privacyDescription: 'Gestionează setările de confidențialitate',
    content: 'Conținut',
    contentDescription: 'Configurează cum interacționezi cu conținutul',
    payment: 'Plăți',
    paymentDescription: 'Setează fluxul de plată preferat',
    notifications: 'Notificări',
    notificationsDescription: 'Alege ce notificări vrei să primești',
    noSettings: 'Nu sunt setări disponibile',
    theme: 'Temă',
    language: 'Limbă',
  },

  // Help & About
  helpAbout: {
    share: 'Distribuie',
    shareDescription: 'Distribuie Expause pe alte platforme',
    feedback: 'Feedback',
    feedbackDescription: 'Spune-ne ce părere ai despre aplicație sau dacă ai găsit probleme',
    contact: 'Contact',
    contactDescription: 'Ia legătura cu serviciul nostru pentru clienți',
    support: 'Asistență',
    supportDescription: 'Află cum funcționează sau trimite o solicitare dacă ai nevoie de ajutor',
    legalDocuments: 'Documente legale',
    legalDocumentsDescription: 'Toate documentele cu care ești de acord',
    about: 'Despre Expause',
    aboutDescription: 'Expause este despre conținut valoros, confidențialitate și monetizare. Atinge pentru mai multe',
    appVersion: 'Versiune',
  },

  // Contact
  contact: {
    title: 'Contact',
    supportSectionLabel: 'Verifică secțiunea de Suport dacă ai nevoie de ajutor',
    supportLink: 'Suport',
    mailSectionLabel: 'Contactează-ne prin email',
    mailAddress: 'support@expause.com',
    requestSectionLabel: 'Trimite o solicitare și te vom contacta',
    contentPlaceholder: 'Descrie solicitarea (opțional)',
    emailPlaceholder: 'Introdu adresa de email (obligatoriu)',
    submitButton: 'Trimite',
    emailEmptyTitle: 'Trimite',
    emailEmptyMessage: 'Te rugăm să completezi adresa de email',
    emailInvalidTitle: 'Invalid',
    emailInvalidMessage: 'Te rugăm să introduci o adresă de email validă',
    confirmTitle: 'Trimite',
    confirmMessage: 'Trimiteți solicitarea de suport?',
    confirmYes: 'Da',
    confirmNo: 'Nu',
    successTitle: 'Succes',
    successMessage: 'Solicitarea ta a fost trimisă cu succes',
    errorTitle: 'Eroare',
    errorMessage: 'A apărut o eroare la trimiterea solicitării. Te rugăm să încerci din nou!',
  },

  // Support
  support: {
    title: 'Suport',
    requestSectionLabel: 'Dacă nu găsești un răspuns, trimite o solicitare și te vom contacta',
    openPrivacyPolicyLink: 'Deschide Politica de Confidențialitate',
    categoryLabels: {
      account: 'Cont',
      appUsage: 'Cum se folosește aplicația',
      premium: 'Pachete Premium',
      wallet: 'Portofel',
      privacy: 'Confidențialitate',
      report: 'Raportări',
      supportRequest: 'Solicitare suport',
      policies: 'Politici',
      unknown: 'Necunoscut',
    },
    items: {
      createAccount: {
        title: 'Creează un cont',
        description: 'Crearea unui cont se poate face din ecranul de Autentificare prin autentificare cu Apple sau Google. Dacă nu te-ai înregistrat înainte, un cont va fi creat pentru tine. Dacă ai deja un cont și te autentifici din ecranul de Autentificare, vei primi doar drepturile de acces la aplicație, iar contul tău nu va fi actualizat.',
      },
      deleteAccount: {
        title: 'Șterge un cont',
        description: 'Pentru a-ți șterge contul, trebuie să mergi în Profilul tău, să apeși butonul Mai mult din bara de sus, apoi să selectezi Setări și să alegi Șterge contul. Toate datele legate de tine vor fi pierdute definitiv, inclusiv monedele tale, banii câștigați și abonamentele tale premium. ',
      },
      profileSetup: {
        title: 'Configurarea profilului',
        description: 'Îți poți configura contul prima dată când te înregistrezi în aplicație. Poți alege o fotografie de profil, introduce numele tău complet, alege un nume de utilizator, adăuga o descriere despre tine dacă dorești și alege o taxă de abonament pe care alții să ți-o plătească lunar dacă vor să se aboneze. Poți edita aceste detalii oricând din secțiunea Profil a aplicației.',
      },
      uploadContent: {
        title: 'Încarcă conținut',
        description: "Încărcarea unui videoclip se poate face din Profilul tău apăsând pictograma '+'. Poți înregistra un videoclip sau poți încărca un videoclip existent din biblioteca media a dispozitivului tău. Dacă durata videoclipului tău este mai mare decât durata maximă permisă, îl poți decupa în ecranul următor. De asemenea, poți alege unde începe partea Exclusivă a videoclipului. Videoclipul Exclusiv este disponibil doar pentru abonații tăi. Din ecranul Încarcă Conținut poți, de asemenea, adăuga o descriere, adăuga hashtaguri, menționa alte persoane și alege setări de confidențialitate legate de conținut.",
      },
      subscribeToOthers: {
        title: 'Abonează-te la alții',
        description: 'Te poți abona la alte persoane vizitând secțiunea Profil a acestora și apăsând butonul Abonează-te. Trebuie să ai suficiente monede în soldul tău pentru a acoperi taxa stabilită de acel utilizator (poate fi gratuit dacă utilizatorul nu a stabilit nicio taxă de abonament). Taxele de abonament sunt plătite lunar (30 de zile) și se bazează pe monedele pe care le achiziționezi din Magazin. Acestea se reînnoiesc doar dacă ai suficiente monede în portofel.',
      },
      sendGifts: {
        title: 'Trimite cadouri',
        description: 'Le poți trimite altora cadouri pentru conținutul lor, în ecranul Mesaje directe sau în timpul sesiunilor Live. Toate cadourile sunt plătite cu monede pe care le achiziționezi din Magazinul subiacent.',
      },
      directMessaging: {
        title: 'Mesagerie directă',
        description: 'Pentru a avea o sesiune de Mesaje directe cu o altă persoană, trebuie să ai un abonament Exclusiv activ la acea persoană sau viceversa. Mesajele directe sunt criptate end-to-end, ceea ce înseamnă că doar voi doi puteți decripta și citi mesajele. Vă puteți trimite reciproc mesaje text, foto și video. De asemenea, puteți avea un apel video unde sunt acceptate cadouri. Mesajele nu sunt șterse atunci când abonamentele Exclusive sunt anulate.',
      },
      communities: {
        title: 'Comunități',
        description: 'Comunitățile sunt locuri unde persoanele abonate la un utilizator pot avea un chat de grup și pot participa, de asemenea, la sesiunea de streaming Live a utilizatorului. Pentru a accesa comunitatea unui utilizator, trebuie să ai un abonament Exclusiv activ la acel utilizator.',
      },
      directVideoCalls: {
        title: 'Apeluri video directe',
        description: 'Poți avea apeluri video cu un utilizator dacă ai un abonament Exclusiv activ la acel utilizator sau viceversa. Pentru a începe un apel video, trebuie să accesezi ecranul Chat cu acel utilizator, fie din secțiunea Profil a utilizatorului, fie din ecranul Mesaje. Cadourile sunt permise în timpul Apelurilor video și sunt susținute de monede pe care le poți achiziționa din Magazinul subiacent.',
      },
      liveSessions: {
        title: 'Sesiuni Live',
        description: 'Poți participa la o sesiune de streaming Live începută de un utilizator la care te-ai abonat. O poți accesa din butonul Comunitate din secțiunea Profil a utilizatorului sau din ecranul Mesaje când există o notificare pentru o nouă sesiune Live. Pentru a începe o sesiune live tu însuți/însăți, mergi în Profilul tău, apasă butonul Comunitate și apasă butonul LIVE din bara de sus a aplicației. Cadourile sunt permise în timpul streamingului Live și sunt susținute de monede pe care le poți achiziționa din Magazinul subiacent.',
      },
      premiumPackages: {
        title: 'Pachete Premium',
        description: 'Pachetele Premium îți oferă acces la funcții suplimentare în Expause. Pentru a activa un pachet premium, mergi în Profilul tău și apasă butonul cu imaginea Coroanei Premium. Dacă alegi să activezi un pachet premium, vei plăti cu contul tău de achiziții din Magazin. \nExistă pachete premium care oferă beneficii atât creatorilor de conținut, cât și consumatorilor de conținut. Vizitează secțiunea Pachete Premium din aplicație pentru a afla mai multe.',
      },
      buyCoins: {
        title: 'Cumpără monede',
        description: 'Poți cumpăra monede pentru a trimite altora cadouri sau pentru a activa abonamente Exclusive către alții. Achiziționarea de monede se face doar prin Magazinul subiacent.',
      },
      monetize: {
        title: 'Monetizează',
        description: 'Monedele pe care alții le cheltuiesc pentru a-ți trimite cadouri sunt transformate în Diamante, pe care le poți retrage apoi sub formă de bani reali. Pentru a încasa, trebuie să ai un cont Revolut conectat la portofelul tău Expause. Poți retrage o dată pe zi până la 1 000 USD (schimbat în propria ta monedă). De asemenea, poți activa pachetul Consumer Pro, care îți va permite să retragi automat de fiecare dată când câștigi 100 USD, astfel încât să nu trebuiască să-ți faci griji cu privire la limitele de retragere.',
      },
      linkRevolut: {
        title: 'Conectează Revolut',
        description: 'Pentru a-ți retrage Diamantele câștigate, trebuie să-ți conectezi Revolut la portofelul tău Expause. Numele tău complet și revtag-ul tău sunt necesare pentru ca Expause să comunice cu Revolut. Expause stochează doar ID-ul contului tău Revolut. Toate datele financiare sensibile sunt stocate de partea Revolut. Expause nu poate efectua plăți din contul tău către alte conturi.',
      },
      privacyPolicyAgreement: {
        title: 'Acord privind politica de confidențialitate',
        description: 'Acord privind politica de confidențialitate',
      },
      contentPrivacy: {
        title: 'Confidențialitatea conținutului',
        description: 'Când încarci un videoclip, poți seta câteva setări de confidențialitate. Poți alege dacă permiți non-abonaților să deblocheze un videoclip exclusiv. Dacă este permis, alții pot accesa videoclipul tău o singură dată dacă îți plătesc o sumă echivalentă cu 100 de monede. De asemenea, poți alege dacă vrei să permiți previzualizările Exclusive. Făcând asta, utilizatorii care au pachetul Consumer Pro pot vedea o secvență de previzualizări de imagini neclare din partea Exclusivă a videoclipului. Acest lucru îi face mai curioși și mai înclinați să devină abonați. Poți alege, de asemenea, dacă vrei să permiți comentarii pentru acel videoclip sau să afișezi cantitatea de monede câștigate pentru acel videoclip.',
      },
      accountPrivacy: {
        title: 'Confidențialitatea contului',
        description: 'Expause nu stochează nicio informație sensibilă despre tine și nu împarte sau vinde date despre tine sau activitatea ta. \nDacă vrei să alegi cine poate avea un abonament Exclusiv la tine, există o opțiune pentru asta. O poți găsi în secțiunea Setări a aplicației. Activând-o, utilizatorii care doresc să se aboneze vor trebui să aștepte aprobarea ta înainte de a primi acces la conținutul tău Exclusiv, Mesagerie directă, Comunitate și streaming Live.',
      },
      reportContent: {
        title: 'Raportează conținut',
        description: 'Dacă găsești conținut care pare să fie împotriva termenilor Expause sau dacă pur și simplu îl găsești ofensator, poți trimite o Raportare apăsând butonul : (Opțiuni) situat în colțul din dreapta sus al videoclipului. Poți selecta un motiv pentru Raportare și oferi câteva detalii suplimentare dacă dorești. Vom analiza Raportarea și conținutul cât mai curând posibil și vom lua măsurile corespunzătoare. Conținutul raportat va fi eliminat dacă constatăm că încalcă termenii de utilizare Expause.',
      },
      reportAccount: {
        title: 'Raportează un cont',
        description: 'Dacă crezi că o persoană desfășoară unele activități (în camerele de chat sau în timpul apelurilor video sau al sesiunilor Live) sau deține conținut care sunt împotriva termenilor Expause, poți trimite o Raportare apăsând butonul : (Opțiuni) situat în colțul din dreapta sus al secțiunii de profil a utilizatorului. Poți selecta un motiv pentru Raportare și oferi câteva detalii suplimentare dacă dorești. Vom analiza Raportarea cât mai curând posibil și vom lua măsurile corespunzătoare. Utilizatorul va fi blocat și contul eliminat dacă constatăm că încalcă termenii de utilizare Expause.',
      },
      submitRequest: {
        title: 'Trimite o solicitare de suport',
        description: 'Descriere solicitare de suport',
      },
    },
  },

  // About (About Expause static-content page)
  about: {
    sections: {
      exclusiveContent: {
        title: 'Conținut exclusiv',
        items: [
          'Abonează-te la creatori de conținut și',
          'Accesează videoclipurile lor exclusive',
          'Discută cu ei',
          'Efectuează apeluri video private',
          'Alătură-te comunității lor LIVE',
        ],
      },
      liveStreaming: {
        title: 'Transmisiuni LIVE',
        items: [
          'Transmite LIVE în comunitatea ta',
          'Doar abonații se pot alătura',
        ],
      },
      topMonetization: {
        title: 'Monetizare de top',
        items: [
          'Fără taxe de tranzacție la retragere',
          'Recompense de top',
          'Fără limite de retragere cu Premium',
          'Retragere automată cu Premium',
        ],
      },
      privacy: {
        title: 'Confidențialitate',
        items: [
          'Fără reclame',
          'Fără vânzarea informațiilor personale',
        ],
      },
    },
  },

  // Mock Chat (dev-only harness for VirtualList reversed mode)
  mockChat: {
    title: 'Chat de test',
    placeholder: 'Scrie un mesaj…',
  },

  // Chat (direct messaging — ChatPage and its subcomponents)
  chat: {
    appBar: {
      videoCall: 'Apel video',
      more: 'Mai multe',
    },
    actions: {
      blockConversation: 'Blochează conversația',
      unblockConversation: 'Deblochează conversația',
      blockUser: 'Blochează pe {peerFirstName}',
      unblockUser: 'Deblochează pe {peerFirstName}',
      muteNotifications: 'Dezactivează notificările',
      unmuteNotifications: 'Activează notificările',
      blockUserTitle: 'Blochează pe {peerFirstName}',
      unblockUserTitle: 'Deblochează pe {peerFirstName}',
      blockUserDescription:
        'Nu va putea să îți trimită mesaje directe, să îți vadă profilul sau videoclipurile tale. Încă vă puteți vedea reciproc în comunitățile comune. Orice abonament Exclusiv în curs va fi anulat. Nu va fi notificat că l-ai blocat.',
      unblockUserDescription:
        'Va putea să îți trimită mesaje directe, să îți vadă profilul sau videoclipurile tale.',
      blockUserConfirm: 'Blochează',
      unblockUserConfirm: 'Deblochează',
      blockUserError: 'A apărut o eroare. Te rugăm să încerci din nou!',
      blockConversationTitle: 'Blochează conversația',
      unblockConversationTitle: 'Deblochează conversația',
      blockConversationDescription:
        'Conversația nu va fi ștearsă, dar {peerFirstName} nu îți va mai putea trimite mesaje directe. Veți putea în continuare să accesați profilurile și conținutul celuilalt. De asemenea, veți putea vedea mesajele celuilalt în Comunitățile comune. {peerFirstName} nu va fi notificat că ai blocat conversația.',
      unblockConversationDescription:
        'Veți putea să vă trimiteți mesaje directe unul altuia.',
      blockConversationConfirm: 'Blochează',
      unblockConversationConfirm: 'Deblochează',
      // Reutilizat de fluxul de dezactivare/activare a notificărilor (Flutter
      // afișează același mesaj de eroare și reutilizează share.success „Done” —
      // fără chei dedicate pentru mute).
      blockConversationError: 'A apărut o eroare. Te rugăm să încerci din nou!',
      muteConversationTitle: 'Dezactivează conversația',
      unmuteConversationTitle: 'Activează conversația',
      muteConversationDescription:
        'Nu vei primi notificări pentru mesajele directe de la {peerFirstName}',
      unmuteConversationDescription:
        'Vei primi notificări pentru mesajele directe de la {peerFirstName}',
      muteConversationConfirm: 'Dezactivează',
      unmuteConversationConfirm: 'Activează',
    },
    composer: {
      placeholder: 'Scrie un mesaj...',
      conversationBlocked: 'Conversație blocată',
      giftAriaLabel: 'Trimite un cadou',
    },
    overlay: {
      accountBlocked: 'Contul tău este blocat!',
      conversationNotAvailable: 'Conversație indisponibilă!',
      peerAccountBlocked: 'Contul lui {peerName} este blocat',
    },
    subscribeBlurb:
      'Abonează-te pentru a accesa videoclipurile Exclusive ale lui {peerName}, Acces Anticipat la videoclipuri programate, Mesaje Directe, Apeluri Video Private, Streaming LIVE și Comunitate',
    subscribeButton: 'Abonează-te',
    emptyEncrypted:
      'Mesajele cu {peerFirstName} sunt criptate end-to-end. Salută!',
    checkingForInternet: 'Se verifică conexiunea la Internet',
    errorSendingMessage:
      'A apărut o eroare la trimiterea mesajului. Apasă pe mesaj pentru a reîncerca!',
    unread: {
      gift: '{peerFirstName} ți-a trimis un cadou',
      photo: '{peerFirstName} a trimis o poză',
      video: '{peerFirstName} a trimis un video',
    },
    gift: {
      youSent: 'Ai trimis un cadou',
      peerSent: '{peerName} ți-a trimis un cadou',
    },
    uploading: {
      image: 'Se procesează imaginea',
      video: 'Se procesează videoclipul',
    },
    videoCall: {
      titleOwn: 'Ai inițiat un apel video',
      titlePeerStarted: 'A inițiat un apel video',
      titlePeer: 'Apel video',
      statusInProgress: 'În desfășurare',
      statusTapToJoin: 'Apasă pentru a te alătura',
      statusFailed: 'Eșuat',
    },
    videoCallPage: {
      callingUser: 'Se apelează {name}',
      callEnded: 'Apel încheiat',
      couldNotJoin: '{name} nu s-a putut alătura apelului video',
      regeneratingToken:
        'Tokenul de autentificare pentru streaming a expirat. Se generează un nou token...',
      couldNotJoinToast:
        'Nu te-ai putut alătura apelului video. Te rugăm să încerci din nou!',
      tokenRegenFailedToast:
        'Nu s-a putut genera un nou token de autentificare pentru streaming. Apelul video s-a încheiat.',
      permissionDeniedToast: 'Te rugăm să acorzi permisiunea pentru {permission}',
      permissionDeniedDevices: 'cameră și microfon',
      confirmEndTitle: 'Apel video',
      confirmEndDescription: 'Închizi apelul video?',
      confirmStartDescription: 'Inițiezi un apel video cu {name}?',
      remoteVideoLabel: 'Video interlocutor',
      swapVideoLabel: 'Schimbă vizualizările video',
      endCallLabel: 'Încheie apelul',
      muteLabel: 'Microfon',
      cameraLabel: 'Cameră',
      switchCameraLabel: 'Schimbă camera',
      giftLabel: 'Trimite cadou',
      argsMissingError: 'Un apel video poate fi inițiat doar din conversație.',
      sentGift: '{name} a trimis un cadou',
      you: 'Tu',
    },
    mediaDetails: {
      title: 'Media',
      argsMissingError: 'Acest fișier media poate fi deschis doar din conversație.',
      imageError: 'Această imagine nu a putut fi încărcată.',
      videoError: 'Acest videoclip nu a putut fi încărcat.',
      processingTitle: 'Se procesează',
      processingDescription: 'Acest fișier media este încă în curs de procesare. Te rugăm să revii într-un moment.',
      failedTitle: 'Media indisponibilă',
      failedDescription: 'Acest fișier media nu a putut fi trimis și nu poate fi deschis.',
    },
  },

  dateFormatters: {
    callDuration: {
      seconds: 'secunde',
      minute: 'minut',
      minutes: 'minute',
      hour: 'oră',
      hours: 'ore',
      joiner: 'și',
    },
  },

  inbox: {
    updatesHeader: 'Actualizări',
    directMessagesHeader: 'Mesaje directe',
    moreUpdates: 'Mai multe actualizări',
    emptyPlaceholder: 'Actualizările și mesajele directe apar aici',
    notifications: {
      likedYourImage: '{name} ți-a apreciat imaginea',
      likedYourVideo: '{name} ți-a apreciat videoclipul',
      unlikedYourImage: '{name} ți-a retras aprecierea imaginii',
      unlikedYourVideo: '{name} ți-a retras aprecierea videoclipului',
      commentedOnYourImage: '{name} a comentat la imaginea ta',
      commentedOnYourVideo: '{name} a comentat la videoclipul tău',
      removedCommentOnYourImage: '{name} și-a șters comentariul de la imaginea ta',
      removedCommentOnYourVideo: '{name} și-a șters comentariul de la videoclipul tău',
      likedYourComment: '{name} ți-a apreciat comentariul',
      unlikedYourComment: '{name} ți-a retras aprecierea comentariului',
      repliedToYourComment: '{name} a răspuns la comentariul tău',
      removedReplyToYourComment: '{name} și-a șters răspunsul la comentariul tău',
      sentYouAGift: '{name} ți-a trimis un cadou',
      mentionedYouInPhoto: '{name} te-a menționat într-o fotografie',
      mentionedYouInVideo: '{name} te-a menționat într-un videoclip',
      mentionedYouInComment: '{name} te-a menționat într-un comentariu',
      unlockedFullVideo: '{name} a deblocat videoclipul complet',
      videoScheduled: 'Videoclipul tău a fost programat',
      videoScheduledEarlyAccessSuffix: ' cu Acces Anticipat pentru abonații tăi',
      videoPublished: 'Videoclipul tău a fost publicat',
      payPremiumVideoSuccess: 'Plata pentru Videoclipul tău Premium a fost procesată cu succes',
      payPremiumVideoFailed: 'Plata pentru Videoclipul tău Premium a eșuat. Apasă pentru a reîncerca',
      payBoostVideoSuccess: 'Plata pentru Promovarea videoclipului tău a fost procesată cu succes',
      payBoostVideoFailed: 'Plata pentru Promovarea videoclipului tău a eșuat. Apasă pentru a reîncerca',
      earlyAccessReceivedBody: 'Ți-a permis Acces Anticipat la un videoclip programat',
      reportContentImageTitle:
        'Imaginea ta a fost blocată deoarece a încălcat Termenii noștri de Utilizare!',
      reportContentVideoTitle:
        'Videoclipul tău a fost blocat deoarece a încălcat Termenii noștri de Utilizare!',
      reportContentSubtitle:
        'Nu va fi disponibilă pentru ceilalți în fluxul lor, dar o poți accesa în continuare din profilul tău și poți depune o contestație.',
      zeroLikes: '0 aprecieri',
      oneLike: '1 apreciere',
      manyLikes: '{count} aprecieri',
      zeroComments: '0 comentarii',
      oneComment: '1 comentariu',
      manyComments: '{count} comentarii',
      zeroReplies: '0 răspunsuri',
      oneReply: '1 răspuns',
      manyReplies: '{count} răspunsuri',
      totalSubtitle: 'Total: {value} - {date}',
      totalPrefix: 'Total: ',

      exclusiveSubscribed: '{name} s-a abonat',
      exclusiveUnsubscribed: '{name} s-a dezabonat',
      exclusiveSubscriptionCancelled:
        '{name} a anulat abonamentul. Accesul este în continuare permis până la expirarea abonamentului',
      exclusiveRenewedSelf: 'Abonamentul tău la {name} a fost reînnoit',
      exclusiveRenewedOther: 'Abonamentul exclusiv al lui {name} a fost reînnoit',
      exclusiveExpiredSelf: 'Abonamentul tău la {name} a expirat',
      exclusiveExpiredOther: 'Abonamentul lui {name} a expirat',
      exclusiveRequested: '{name} a solicitat să se aboneze',
      exclusiveRequestCancelled: '{name} a anulat cererea de abonare',
      exclusiveRequestAcceptedSelf: 'Ai acceptat cererea de abonare a lui {name}',
      exclusiveRequestAcceptedOther: '{name} ți-a acceptat cererea de abonare',
      exclusiveRequestDeclinedSelf: 'Ai respins cererea de abonare a lui {name}',
      exclusiveRequestDeclinedOther: '{name} ți-a respins cererea de abonare',
      exclusiveFailedInsufficientSelf:
        'Abonarea la {name} a eșuat din cauza monedelor insuficiente',
      exclusiveFailedInsufficientOther: '{name} nu a reușit să se aboneze',

      reportUserTitle: 'Contul tău a fost blocat din cauza încălcărilor multiple ale Politicii!',
      reportUserSubtitle:
        'Alte persoane nu îl vor mai putea vizualiza. Îl poți accesa în continuare din Profilul tău și poți depune o contestație.',

      identityVerificationTitle: 'Verificarea Identității',
      identityRequested: 'Echipa noastră îți va analiza cererea cât mai curând posibil',
      identityInReview: 'Cererea ta este analizată de echipa noastră',
      identityApproved:
        'Cererea ta a fost aprobată. Ai primit insigna Identitate Albastră',
      identityDeclined: 'Cererea ta a fost respinsă. Motiv: {reason}',
      identityDeclineReasons: {
        unclearDocument: 'Imaginea documentului este neclară',
        unclearLiveness: 'Videoclipul de verificare a feței este neclar',
        unclearUploadedFiles:
          'Imaginea documentului și videoclipul de verificare a feței sunt neclare',
        missmatchUploadedFiles:
          'A existat o nepotrivire între documentul de identitate și videoclipul de verificare',
        missmatchUploadedFilesProfile:
          'A existat o nepotrivire între documentul de identitate, videoclipul de verificare și profilul utilizatorului',
        premiumPackageExpired: 'Pachetul de Identitate a expirat',
        identityDataChanged: 'Datele de identitate s-au schimbat',
      },

      premiumPackageEarned: 'Câștigat prin Premium {packageName}',
      premiumPackageExpired: 'Abonamentul tău la Premium {packageName} a expirat',

      campaignEnded: 'Campania {title} s-a încheiat',
      rank1st: 'locul 1',
      rank2nd: 'locul 2',
      rank3rd: 'locul 3',
      campaignRankingSubtitle:
        'Ai fost clasat pe {rank}. Te vom contacta în legătură cu recompensa ta!',

      roadmapLiked: '{name} ți-a apreciat Ideea',
      roadmapDisliked: '{name} nu ți-a apreciat Ideea',
      roadmapCommented: '{name} a comentat la Ideea ta',
      roadmapCommentReplied: '{name} a răspuns la comentariul Ideii tale',
      roadmapCommentLiked: '{name} ți-a apreciat comentariul Ideii',
      roadmapCommentUnliked: '{name} ți-a retras aprecierea comentariului Ideii',
      roadmapDonated: '{name} a donat pentru a susține Ideea ta',
      zeroDislikes: '0 neaprecieri',
      oneDislike: '1 neapreciere',
      manyDislikes: '{count} neaprecieri',
      donationUsd: '{value} USD',
    },
    chat: {
      youColon: 'Tu: {content}',
      youSentImage: 'Ai trimis o imagine',
      sentImage: '{name} a trimis o imagine',
      youSentVideo: 'Ai trimis un videoclip',
      sentVideo: '{name} a trimis un videoclip',
      youSentGift: 'Ai trimis un cadou',
      sentGift: '{name} a trimis un cadou',
      youStartedVideoCall: 'Ai inițiat un apel video',
      startedVideoCall: '{name} a inițiat un apel video',
      youSharedUserProfile: 'Ai distribuit un profil de utilizator',
      sharedUserProfile: '{name} a distribuit un profil de utilizator',
      youSharedPhoto: 'Ai distribuit o fotografie',
      sharedPhoto: '{name} a distribuit o fotografie',
      youSharedVideo: 'Ai distribuit un videoclip',
      sharedVideo: '{name} a distribuit un videoclip',
    },
    notificationTap: {
      contentAlreadyPublished: 'Conținutul a fost deja publicat',
      retryPremiumVideoTitle: 'Plata a eșuat pentru videoclipul tău Premium',
      retryBoostVideoTitle: 'Plata a eșuat pentru promovarea videoclipului tău',
      retryPaymentDescription:
        'Videoclipul tău este gata, dar nu este disponibil pentru ceilalți deoarece plata a eșuat.\n\nPoți relua plata acum. Asigură-te că ai {coins} monede în Portofel.',
      retryPayment: 'Reia plata',
      retryPaymentSuccess: 'Gata',
      retryPaymentError: 'A apărut o eroare. Te rugăm să încerci din nou!',
    },
  },

  // Legal Documents
  legal: {
    title: 'Documente legale',
    termsOfUse: 'Termeni de Utilizare',
    termsOfUseDescription: 'Termenii principali care guvernează utilizarea Platformei',
    coinsPolicy: 'Politica Monedelor',
    coinsPolicyDescription: 'Politica privind achiziționarea și utilizarea Monedelor pe Platformă',
    rewardsPolicy: 'Politica Recompenselor',
    rewardsPolicyDescription: 'Politica privind recompensele pe care le primești și cum poți retrage bani reali din Platformă',
    exclusiveSubscriptionsPolicy: 'Politica privind Abonamentele Exclusive',
    exclusiveSubscriptionsPolicyDescription: 'Reguli care se aplică atunci când achiziționezi un Abonament Exclusiv către alte persoane de pe Platformă',
    premiumSubscriptionsPolicy: 'Politica Pachetelor Premium',
    premiumSubscriptionsPolicyDescription: 'Reguli care se aplică atunci când achiziționezi un Abonament Premium pe Platformă prin Magazine terțe precum Apple sau Google Stores',
    privacyPolicy: 'Politica de Confidențialitate',
    privacyPolicyDescription: 'Reguli privind modul în care datele tale sunt colectate, utilizate și protejate pe Platformă',
    communityGuidelines: 'Regulile Comunității',
    communityGuidelinesDescription: 'Reguli și standarde pentru conținut și comportament pe Platformă',
  },

  // Search
  search: {
    placeholder: 'Caută persoane și conținut',
    people: 'Persoane',
    content: 'Conținut',
    morePeople: 'Mai multe persoane',
    subscriber: 'abonat',
    subscribers: 'abonați',
    post: 'postare',
    posts: 'postări',
    use: 'utilizare',
    uses: 'utilizări',
  },
  latestUsers: {
    title: 'Utilizatori',
    you: 'Tu',
    noName: 'Fără nume',
    created: 'Creat',
    lastSeen: 'Văzut ultima dată',
  },
  contentUsersLiked: {
    zeroLikes: '0 aprecieri',
    oneLike: '1 apreciere',
    manyLikes: '{count} aprecieri',
    noLikesYet: 'Nicio apreciere încă',
  },
  roadmapItemLikes: {
    zeroLikes: '0 aprecieri',
    oneLike: '1 apreciere',
    manyLikes: '{count} aprecieri',
    zeroDislikes: '0 neaprecieri',
    oneDislike: '1 neapreciere',
    manyDislikes: '{count} neaprecieri',
    noLikesYet: 'Nicio apreciere încă',
    noDislikesYet: 'Nicio neapreciere încă',
  },
  contentTags: {
    noContent: 'Niciun conținut găsit pentru acest tag',
    errorLoading: 'Eroare la încărcarea conținutului',
    tagNameRequired: 'Numele tag-ului este obligatoriu',
    fetchFailed: 'Eroare la încărcarea conținutului',
    loadMoreFailed: 'Eroare la încărcarea mai multor conținuturi',
  },

  // Unlocked Videos
  unlockedVideos: {
    empty: 'Videourile deblocate vor apărea aici',
    errorLoading: 'Eroare la încărcarea videourilor deblocate',
    loadMoreFailed: 'Eroare la încărcarea mai multor videouri deblocate',
  },

  // Liked Videos
  likedVideos: {
    empty: 'Videourile apreciate vor apărea aici',
    errorLoading: 'Eroare la încărcarea videourilor apreciate',
    loadMoreFailed: 'Eroare la încărcarea mai multor videouri apreciate',
  },

  // Saved Content (Watch later)
  savedContent: {
    empty: 'Videourile salvate pentru mai târziu vor apărea aici',
    errorLoading: 'Eroare la încărcarea videourilor salvate',
    loadMoreFailed: 'Eroare la încărcarea mai multor videouri salvate',
  },

  // Saved Users (Favourite people)
  savedUsers: {
    empty: 'Persoanele salvate vor apărea aici',
    errorLoading: 'Eroare la încărcarea persoanelor favorite',
    loadMoreFailed: 'Eroare la încărcarea mai multor persoane favorite',
  },

  // Subscriptions
  subscriptions: {
    empty: 'Abonamentele tale la creatori vor apărea aici',
  },

  // Subscribers
  subscribers: {
    titleSingular: '1 abonat',
    titlePlural: '{count} abonați',
    empty: 'Abonații tăi vor apărea aici. Distribuie-ți profilul pentru a câștiga abonați!',
    shareProfileButton: 'Distribuie profil',
    errorLoading: 'Eroare la încărcarea abonaților',
    loadMoreFailed: 'Eroare la încărcarea mai multor abonați',
  },

  // Publish
  publish: {
    selectContentTypeTitle: 'Publică Conținut',
    selectContentTypeDescription: 'Alege cum vrei să distribui conținutul',
    upload: 'Încarcă',
    goLive: 'LIVE',
    addContentTitle: 'Încarcă Video',
    commentReplyTitle: 'Răspunde la comentariu',
    chatAddContentTitle: 'Trimite Media',
    chatPreviewTitle: 'Previzualizare',
    chatDoneButton: 'Gata',
    chatUploadError: 'A apărut o eroare la trimiterea fișierului media. Te rugăm să încerci din nou!',
    confirmSendChatMediaTitle: 'Trimite media',
    confirmSendChatMediaDescription: 'Ești sigur că vrei să trimiți acest fișier media?',
    previewTitle: 'Previzualizare',
    descriptionTitle: 'Descriere',
    settingsTitle: 'Setări',
    dropVideoHere: 'Trage fișierul video aici',
    dropVideoDescription: 'Trebuie să fie între {min} secunde și {max} minute.',
    dropMediaHere: 'Trage imaginea sau videoclipul aici',
    dropMediaDescription: 'Videoclipurile pot avea până la {max} minute.',
    dropImageTitle: 'Trage fișierul imagine aici',
    dropImageDescription: 'Formate acceptate: JPG, PNG și WebP.',
    browseFiles: 'Caută fișiere',
    unsupportedFormat: 'Format video neacceptat',
    unsupportedFormatMessage: 'Te rugăm să selectezi un video în format MP4, MOV, WebM, AVI sau MKV.',
    unsupportedDuration: 'Durată video neacceptată',
    unsupportedDurationMessage: 'Te rugăm să selectezi un video între {min} secunde și {max} minute.',
    premiumVideo: 'Video Premium',
    premiumVideoMessage: 'Primele {freeMin} minute sunt gratuite. Apoi {coinsPerMin} Monede pe minut pentru videouri Premium.\n\nPublicarea acestui video va costa {coins} Monede din portofel.',
    videoReady: 'Video pregătit',
    unsupportedPreview: 'Previzualizarea nu este disponibilă pentru acest format. Videoclipul se va încărca și va putea fi vizionat după procesare.',
    uploadVideoTitle: 'Încarcă video',
    uploadVideoDescription: 'Videoclipurile au o secțiune publică vizibilă tuturor și o secțiune privată accesibilă doar abonaților.',
    descriptionPlaceholder: 'Descrie videoclipul tău...',
    hashtagAdd: 'Adaugă',
    hashtagUses: '{count} utilizări',
    contentSettingsTitle: 'Setări conținut',
    scheduleLabel: 'Programare',
    scheduleDescription: 'Poți publica videoclipul acum sau îl poți salva ca ciornă pentru a-l publica mai târziu. De asemenea, poți programa o dată și oră specifică pentru publicarea automată.',
    scheduleDraft: 'Ciornă',
    schedulePublishNow: 'Publică acum',
    allowEarlyAccessLabel: 'Permite acces anticipat pentru abonați',
    allowEarlyAccessDescription: 'Abonații tăi vor putea viziona videoclipul înainte de a fi publicat pentru public.',
    earlyAccessNotAvailableTitle: 'Acces anticipat indisponibil',
    earlyAccessNotAvailableDescription: 'Doar conținutul programat poate fi setat pentru acces anticipat. Te rugăm să programezi mai întâi conținutul.',
    linkContentLink: 'Conectează cu alte videoclipuri ale tale',
    linkContentDescription: 'Poți conecta acest videoclip de alt videoclip al tău.',
    linkContentSheetTitle: 'Conectează videoclipul',
    linkContentEmpty: 'Niciun videoclip de conectat',
    linkContentUnlink: 'Dezconectează videoclipul',
    allowCommentsLabel: 'Permite comentarii',
    showEarnedCoinsLabel: 'Arată monedele câștigate',
    showEarnedCoinsDescription: 'Dacă să se afișeze numărul de monede cadou câștigate pe acest videoclip.',
    scheduleContentTitle: 'Programare conținut',
    scheduleSaveAsDraft: 'Salvează ca ciornă',
    schedulePublishNowButton: 'Publică acum',
    scheduleButton: 'Programează',
    scheduleContentInfo: 'Conținutul trebuie programat cu cel puțin {minHours} ore în avans și cu cel mult {maxDays} de zile în avans.',
    schedulePremiumRequiredTitle: 'Acțiune premium',
    schedulePremiumRequiredDescription: 'Pachetul Creator Pro este necesar pentru a programa conținut',
    monetizationTitle: 'Monetizare',
    allowPremiumVideoPayment: 'Permite plata pentru video Premium',
    premiumPaymentDescription: 'Primele {minutes} minute sunt gratuite. Apoi {coinsPerMin} Monede pe minut.\nVideoclipurile premium sunt marcate cu o insignă Premium.',
    coinsWillBeChargedFromWallet: '{coins} Monede vor fi retrase din Portofelul tău.',
    boostVideoLabel: 'Boost video',
    boostVideoDescription: 'Atrage mai multă atenție către videoclipul tău!\nVideoclipurile boost nu sunt marcate cu o insignă Boost.',
    boostScheduledInfo: 'Pentru videoclipurile programate, Boost-ul va începe când videoclipul este programat să fie publicat.',
    boostDraftInfo: 'Pentru videoclipurile ciornă, Boost-ul va începe când decizi să publici videoclipul.',
    boostSelect: 'Selectează',
    boostSelected: 'Selectat',
    boostPriceCoins: '{coins} Monede',
    allowVideoUnlock: 'Permite deblocarea videoclipului',
    allowVideoUnlockDescription: 'Setează un preț între {min} și {max} {currency} pentru ca non-abonații să deblocheze videoclipul tău exclusiv. Abonații au deja acces prin abonament.',
    enterAmount: 'Introdu suma',
    coinsWillBeAddedPerUnlock: '{coins} Monede vor fi adăugate în Portofelul tău de fiecare dată când cineva deblochează videoclipul tău.',
    costsOverview: 'Sumar costuri',
    monetizationOverview: 'Sumar monetizare',
    premiumVideoRow: 'Video Premium: {coins} monede',
    videoBoostRow: 'Boost video: {coins} monede',
    earningsRow: 'Câștiguri: {coins} monede pe deblocare',
    profitPointRow: 'Punct de profit: la {n} deblocare video',
    profitPointRowPlural: 'Punct de profit: la {n} deblocări video',
    insufficientCoinsMonetization: 'Monede insuficiente. Mai ai nevoie de {amount} monede. ',
    previousButton: 'Înapoi',
    publishButton: 'Publică',
    saveDraftButton: 'Salvează ciornă',
    publishScheduleButton: 'Programează',
    confirmPublishTitle: 'Publică videoclip',
    confirmPublishDescription: 'Sigur vrei să publici acest videoclip?',
    confirmScheduleTitle: 'Programează videoclipul',
    confirmScheduleDescription: 'Sigur vrei să programezi acest videoclip?',
    confirmDraftTitle: 'Salvează ca ciornă',
    confirmDraftDescription: 'Sigur vrei să salvezi acest videoclip ca ciornă? Poți să-l publici oricând mai târziu.',
    confirmYes: 'Da',
    confirmCancel: 'Anulează',
    uploadingVideo: 'Se încarcă videoclipul. Te rugăm să nu închizi această pagină!',
    uploadError: 'A apărut o eroare la încărcarea videoclipului. Te rugăm să încerci din nou!',
    publishError: 'A apărut o eroare de procesare. Te rugăm să încerci din nou!',
    uploadInProgressTitle: 'Încărcare în curs',
    uploadInProgressDescription: 'Există deja o încărcare de videoclip în curs. Te rugăm să încerci din nou după ce se termină încărcarea!',
  },

  // Comments
  comments: {
    title: 'Comentarii',
    placeholder: 'Adaugă un comentariu...',
    reply: 'Răspunde',
    replyingTo: 'Răspunzi lui {name}',
    replies: 'Răspunsuri',
    viewReplies: 'Vezi răspunsurile ({count})',
    viewMoreReplies: 'Vezi mai multe ({count})',
    hide: 'Ascunde',
    noComments: 'Niciun comentariu încă',
    errorSending: 'Nu s-a putut trimite comentariul',
    errorLiking: 'Nu s-a putut actualiza aprecierea',
    you: 'Tu',
    mediaProcessing: 'Se procesează',
  },

  // Errors
  errors: {
    user: {
      fetchFailed: 'Preluarea utilizatorului a eșuat',
    },
  },

  auth: {
    autoLoggedOutTitle: 'Ai fost deconectat',
    autoLoggedOutDescription:
      'Contul tău Expause tocmai a fost deschis pe un alt dispozitiv. Pentru a-ți păstra contul în siguranță, poți fi autentificat pe un singur dispozitiv în același timp.',
    continueWithGoogle: 'Continuă cu Google',
    continueWithApple: 'Continuă cu Apple',
    removingAccountMessage:
      'Ai solicitat ștergerea contului tău. Datele tale sunt șterse chiar acum. Te rugăm să încerci mai târziu!',
    accountSuspendedTitle: 'Cont suspendat',
    accountSuspendedMessage:
      'Contul tău a fost suspendat din cauza încălcării regulilor comunității noastre. Te rugăm să contactezi asistența pentru mai multe informații.',
    propositionExclusiveContent: 'Conținut exclusiv',
    propositionLiveStreaming: 'Transmisiuni LIVE',
    propositionTopMonetization: 'Monetizare de top',
    learnMore: 'Află mai multe',
    // The two link labels that follow are the standalone document titles
    // (`legal.termsOfUse` / `legal.privacyPolicy`), which are un-articulated in
    // Romanian. The carrier noun `documentele` supplies the definite article so
    // the sentence stays grammatical without changing the shared titles.
    termsNoticePrefix:
      'Prin continuare, confirmi că ai vârsta majoratului în jurisdicția ta și că ești de acord cu documentele ',
    termsNoticeSeparator: ' și ',
    accountSetupError:
      'A apărut o eroare la configurarea contului tău. Te rugăm să încerci mai târziu!',
    appInitError: 'Inițializarea aplicației a eșuat. Te rugăm să încerci din nou.',
  },

  appOverlay: {
    budgetExceededTitle: 'Bugetul Expause a fost depășit',
    budgetExceededMessage:
      'Ne pare foarte rău, dar avem dificultăți cu bugetul nostru și, prin urmare, oprim redarea videoclipurilor, apelurile video și transmisiunile LIVE.\nDacă vrei să ne ajuți să revenim, am aprecia foarte mult dacă ai cumpăra niște monede sau Abonamente Premium.',
    contactButton: 'Contactează-ne',
    legalUpdatedPrefix: 'Ne-am actualizat ',
    legalUpdatedSuffix:
      '. Prin continuarea utilizării platformei, ești de acord cu versiunea actualizată.',
  },

  deleteAccount: {
    pageTitle: 'Șterge contul',
    disclaimerParagraph1:
      'Această acțiune este ireversibilă și toate datele tale vor fi șterse definitiv. Aceasta include profilul tău propriu-zis, conținutul tău, comentariile, mesajele directe și cele din comunitate, notificările, rapoartele trimise de tine, monedele și diamantele tale.',
    disclaimerParagraph2:
      'Dacă ai abonamente Premium active, te rugăm să mergi în Magazin pentru a le anula. Dacă contul tău este blocat sau suspendat, este posibil să nu permitem ștergerea datelor contului tău, așa cum se prevede în Termenii de Utilizare.',
    deleteButton: 'Șterge contul',
    confirmTitle: 'Șterge contul',
    confirmPrompt:
      'Ești sigur că vrei să ștergi contul? Această acțiune nu poate fi anulată.',
    confirmCta: 'Șterge',
    signInPrompt: 'Te rugăm să te autentifici pentru a-ți șterge contul.',
    reauthPrompt:
      'Pentru siguranța ta, te rugăm să te autentifici din nou pentru a continua.',
    successTitle: 'Ștergere solicitată',
    successMessage:
      'Ștergerea contului tău a fost solicitată și este în curs de procesare. Ai fost deconectat.',
    deleteError:
      'Nu am putut procesa solicitarea ta. Te rugăm să încerci din nou.',
    suspendedMessage:
      'Contul tău este suspendat, așa că nu poate fi șters momentan. Te rugăm să contactezi asistența.',
  },

  roadmap: {
    disclaimerIntro:
      'Ai o idee grozavă pentru a îmbunătăți aplicația? \nNe-ar plăcea să aflăm despre ea.\n\nÎți poate aduce și niște bani. Dacă strânge 1000 USD sau mai mult și decidem să o includem în aplicație, vei primi jumătate din suma strânsă.\nVezi ',
    disclaimerRewardsLink: 'Termenii Recompenselor pentru Idei',
    disclaimerOutro: ' pentru a afla mai multe.',
    addIdea: 'Adaugă idee',
    statusOpen: 'Deschis',
    statusInProgress: 'În desfășurare',
    statusCompleted: 'Finalizat',
    statusRejected: 'Respins',
    ideaFrom: 'Idee de la {name}',
    statusLabel: 'Stare: {value}',
    usdRaised: '{value} USD strânși',
    showSupport: 'Arată susținere',
    errorLoading: 'Eroare la încărcarea ideilor',
    loadMoreFailed: 'Nu s-au putut încărca mai multe idei',
    addIdeaTitle: 'Adaugă idee',
    submitConfirmMessage:
      'Odată trimisă, ceilalți pot reacționa la ideea ta și pot dona pentru a-și arăta susținerea',
    submitDoneLabel: 'Gata',
    ideaTitleHint: 'Titlul ideii',
    ideaDescriptionHint: 'Descrierea ideii',
    addIntro:
      'Ceea ce își doresc utilizatorii noștri este cel mai important pentru noi. Te rugăm să te asiguri că ideea ta nu a fost deja propusă de altcineva.',
    addSuccessTitle: 'Idee adăugată',
    addSuccessMessage:
      'Îți mulțumim pentru ideea ta! O vom analiza cât mai curând posibil.',
    addErrorTitle: 'Eroare',
    addErrorMessage: 'Nu am putut salva ideea ta. Te rugăm să încerci din nou!',
    addOkButton: 'Ok',
  },

  campaigns: {
    title: 'Campanii',
    noCampaigns: 'Nu există campanii în acest moment',
    conditions: 'CONDIȚII',
    learnMore: 'Află mai multe',
    liveStats: 'Statistici live',
    results: 'Rezultate',
    you: 'Tu',
    subscribersCount: '{count} abonați',
    likesCount: '{count} aprecieri',
    notStartedTitle: 'Campania nu a început',
    notStartedMessage: 'Campania nu a început încă!',
  },

  feedback: {
    title: 'Feedback',
    errorLoading: 'Încărcarea feedbackului a eșuat',
    empty: 'Niciun feedback încă',
    createdPrefix: 'Creat: ',
    screenshotsPrefix: 'Capturi de ecran: ',
    screenshotsNone: 'Niciuna',
    detailsTitle: 'Feedback',
    notFound: 'Feedback negăsit',
    uploadScreenshotsTitle: 'Încarcă până la trei capturi de ecran (opțional)',
    disclaimer:
      'Fiecare feedback este foarte apreciat. Ne va ajuta să îmbunătățim platforma.',
    inputHint: 'Feedbackul tău...',
    confirmTitle: 'Feedback',
    confirmDescription:
      'Îți mulțumim pentru feedback! Îl vom analiza cât mai curând posibil.',
    confirmSend: 'Trimite',
    done: 'Gata',
    screenshotViewerTitle: 'Captură feedback',
  },

  defaultMedia: {
    errorNoMedia: 'Niciun conținut de afișat',
  },

  community: {
    titleOwn: 'Comunitatea mea',
    titlePossessive: 'Comunitatea lui {firstName}',
    titlePossessiveApostrophe: 'Comunitatea lui {firstName}',
    subscribeToAccess:
      'Abonează-te pentru a accesa videoclipurile Exclusive ale lui {name}, Acces Anticipat la videoclipuri programate, Mesaje Directe, Apeluri Video Private, Streaming LIVE și Comunitate',
    userBlocked: '{name} a fost blocat',
    emptyStateOwner:
      'Doar abonații pot accesa comunitatea ta. Împreună puteți împărtăși idei, poze, videoclipuri și puteți transmite LIVE.',
    emptyStateVisitor:
      'Fii primul care scrie un mesaj în comunitatea lui {name}',
    shareToGetSubscribers: 'Distribuie pentru a obține abonați',
    composerHintWelcome: 'Întâmpină-ți comunitatea...',
    composerHintDefault: 'Trimite un mesaj...',
    composerHintReply: 'Răspunde lui {name}',
    you: 'Tu',
    errorLikingMessage: 'Nu s-a putut trimite aprecierea mesajului!',
    uploadError: 'A apărut o eroare de procesare. Te rugăm să încerci din nou!',
    processing: 'Se procesează',
    mediaDetails: {
      title: 'Video',
      argsMissingError: 'Acest videoclip poate fi deschis doar din comunitate.',
      videoError: 'Acest videoclip nu a putut fi încărcat.',
    },
    unread: {
      gift: '{name} ți-a trimis un cadou',
      photo: '{name} a trimis o poză',
      video: '{name} a trimis un video',
      // Eroarea de tipar din Flutter „streming” a fost corectată în „streaming”
      // (community_screen.dart:1148, conventions.md „Handling obvious Flutter bugs”).
      live: '{name} a început un Live streaming',
    },
    liveStreamingPage: {
      isNowLive: '{name} este acum Live',
      wasLiveFor: '{name} a fost live timp de {duration}',
      videoLabel: 'Video live',
      switchCameraLabel: 'Schimbă camera',
      muteLabel: 'Microfon',
      cameraLabel: 'Cameră',
      endLiveLabel: 'Încheie live',
      argsMissingError: 'O sesiune Live poate fi deschisă doar din comunitate.',
      permissionDeniedToast: 'Te rugăm să acorzi permisiunea pentru {permission}',
      permissionDeniedDevices: 'cameră și microfon',
      couldNotJoinToast:
        'Nu s-a putut intra în sesiunea Live. Te rugăm încearcă din nou!',
      tokenRegenFailedToast:
        'Nu s-a putut genera un nou token de autentificare pentru streaming. Sesiunea Live s-a încheiat.',
      renewingToken:
        'Tokenul de autentificare pentru streaming a expirat. Se generează un nou token...',
      creatorLeft: 'Creatorul a părăsit întâlnirea',
      endConfirmTitle: 'LIVE',
      endConfirmDescription: 'Închei sesiunea LIVE?',
      goLiveConfirmTitle: 'LIVE',
      goLiveConfirmDescription:
        'Începi o sesiune LIVE? Doar abonații tăi vor putea participa.',
      goLiveConfirmPositive: 'PORNEȘTE LIVE',
      joinConfirmTitle: 'LIVE',
      joinConfirmDescription: 'Intri în LIVE?',
      liveLabel: 'LIVE',
      joinLive: 'Intră în Live',
      alreadyWatchingToast: 'Urmărești deja această sesiune Live în altă filă.',
      youAreLive: 'Ești LIVE',
      liveEnded: 'Live încheiat',
      addComment: 'Adaugă un comentariu...',
      noInternetToast: 'Te rugăm să te conectezi mai întâi la internet!',
      sentGift: '{name} a trimis un cadou',
      you: 'Tu',
      unread: {
        gift: '{name} a trimis un cadou',
        photo: '{name} a trimis o poză',
        video: '{name} a trimis un video',
        // Eroarea de tipar din Flutter „streming” a fost corectată în „streaming”
        // (live_streaming_screen.dart:1655, conventions.md „Handling obvious Flutter bugs”).
        // Bug found on Flutter, web implemented correctly; follow-up recommended to fix Flutter bug.
        live: '{name} a început un Live streaming',
      },
    },
  },
};
